import React from "react";
import { Suspense } from "react";
import Loading from "./TheHousingHubLoading";

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<Loading />}>
      <Component {...props} />
    </Suspense>
  );
};

export default Loadable;
